angular.module('app').factory('pagesService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var pages = restAngular.all("/page/");

        return {
            getPages: function (status) {
                return pages.
                    one("get").
                    customGET(param(status))
            },
            getPagesNames: function (data) {
                return pages.
                    one("getActualPageNames").
                    customGET(param(data))
            },
            getCloserPages: function (data) {
                return pages.
                    one("getCloserPages").
                    customGET(param(data))
            },
            getPageById: function (requestOptions) {
                return pages.
                    one("get").
                    get(requestOptions)
            },
            getPageItemById: function (requestOptions) {
                return pages.
                    one("getitem").
                    get(requestOptions)
            },
            getPageItems: function (requestOptions) {
                return pages.
                    one("getitems").
                    get(requestOptions)
            },
            create: function (pageData) {
                return pages.
                    one("create").
                    post("", pageData)
            },
            createPageItem: function (itemData) {
                return pages.
                    one("createitem").
                    post("", itemData)
            },
            update: function (pageData) {
                return pages.
                    one("change").
                    post("", pageData)
            },
            updatePageItem: function (pageData) {
                return pages.
                    one("changeitem").
                    post("", pageData)
            },
            deleteItem: function (pageData, pageId) {
                var requestObject = {
                    item: {
                        id: pageData.id,
                        page_id: pageId,
                        status: "archive"
                    }
                };
                return pages.
                    one("changeitem").
                    post("", requestObject)
            },
            publishItem: function (pageData, pageId) {
                var requestObject = {
                    item: {
                        id: pageData.id,
                        page_id: pageId,
                        status: "published"
                    }
                };
                return pages.
                    one("changeitem").
                    post("", requestObject)
            },
            getBanners: function () {
                return pages.
                    one("get").
                    get({type: "sidebar"})
            },
            deletePage: function (pageId) {
                var requestData = {
                    id: pageId,
                    status: "archive"
                };
                return pages.
                    one("status").
                    post("", {page: requestData})
            },
            publishPage: function (pageId) {
                var requestData = {
                    id: pageId,
                    status: "published"
                };
                return pages.
                    one("status").
                    post("", {page: requestData})
            },
            getCategories: function (requestData) {
                return pages.
                    one("get").
                    get(requestData)
            },
            groupCategory: function (requestData) {
                return pages.
                    one("getItems").
                    get(requestData)
            },
            changeOrder: function (requestData) {
                return pages.
                    one("changeOrder").
                    post("", requestData)
            },
            getByExternalPath: function (path, requestData) {
                return restAngular.
                    one(path).
                    get()
            }
        }
    }
]);